import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Trans, withI18n } from '@lingui/react';
import NavPanel from './NavPanel';
import { Link } from 'gatsby';
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import moment from 'moment';

// Images
import Facebook from './img/Facebook';
import Instagram from './img/Instagram';
import Twitter from './img/Twitter';
import Ttv from './img/Ttv';
import Youtube from './img/Youtube';
import Canon from './img/Canon';
import Dji from './img/Dji';
import komodo from '../../static/tech/komodo.png';

// styles
import '../styles/style.scss';

class TemplateWrapper extends Component {
  constructor(props) {

    super(props);
    this._$refTemplateWrapper = null;
    this.state = {
      $refTemplateWrapper: null,
      decoratorCls: '',
      showOverlay: false,
      footerBGStyles: {},
      funcDecorator: (cls) => {
        this.setState({
          decoratorCls: cls,
        });
      },
    };
    this.footerWrapperRef = React.createRef();
  }
  
  componentDidMount() {
    const { location } = this.props;
    window.addEventListener('scroll', this.handleScroll);

    this.setState({
      $refTemplateWrapper: this._$refTemplateWrapper,
      showOverlay: !getCookieConsentValue('ps_session')
    });
  }

  handleScroll = () => {
    const currentPos = window.scrollY;
    const viewportHeight = window.innerHeight;
    const visibleArea = currentPos + viewportHeight;

    if (this.footerWrapperRef) {

      const footerRect = this.footerWrapperRef.current.getBoundingClientRect();
      if (footerRect.top + currentPos < visibleArea) {
        const startingPoint = (footerRect.top + currentPos);

        this.setState({
          footerBGStyles: {
            bg1: {
              backgroundPosition: `${Math.min(100, -80 + (visibleArea - startingPoint) * .1)}rem ${Math.min(100,  -45 - (visibleArea - startingPoint) * .05)}rem`
            },
            bg2: {
              backgroundPosition: `${Math.min(100, -80 + (visibleArea - startingPoint) * .15)}rem ${Math.min(100,  -45 - (visibleArea - startingPoint) * .07)}rem`
            }
          }
        });
      }
    }
  }

  onAcceptConsent() {
    this.setState({
      showOverlay: !getCookieConsentValue('ps_session')
    });
  }

  render() {
    const { pathName, children, location } = this.props;
    const isLabPage = pathName.includes('lab') || pathName.includes('process');
    const lightCls = isLabPage ? 'page-is-light' : '';
    
    const {
      $refTemplateWrapper, funcDecorator, decoratorCls, showOverlay, footerBGStyles
    } = this.state;

    const withOverlayCls = showOverlay ? 'with-overlay' : '';

    return (
      <div
        ref={(_mount) => {
          this._$refTemplateWrapper = _mount;
        }}
        className={`main-wrapper ${lightCls} ${decoratorCls} ${withOverlayCls}`}
        >
        <TemplateWrapperContext.Provider
          value={{ $refTemplateWrapper, funcDecorator }}
        >
          <Helmet defaultTitle="Precog Studio" titleTemplate="%s - a Montreal based production house for interactive media, marketing and films">
            <meta name="og:type" content="website" />
            <meta name="og:site_name" content="Precog Studio" />
            <title>Precog Studio</title>
            <meta name="description" content="Precog Studio is a Montreal based production house for interactive media, marketing and films." />
          </Helmet>
          
          <NavPanel
            {...this.props}
          />
          <main className="main-content">
            { children }
          </main>
          <footer className="main-footer" ref={this.footerWrapperRef}>
            <div className="bg-wrapper">
              <div className="bg" style={footerBGStyles.bg1}/>
              <div className="bg _2" style={footerBGStyles.bg2}/>
            </div>
            <div className="wrapper container">
              <div className="col-left">
                  <div className="techs-wrapper">
                    <Canon className="tech-item _canon" />
                    <img src={komodo} alt="komodo" className="tech-item" />
                    <Dji className="tech-item _dji" />
                  </div>
                  <ul className="links-wrapper">
                    <li>
                      <label>Precog Studio&copy; {moment().format('Y')} LLC. ALL RIGHTS RESERVED.</label>
                    </li>
                  </ul>
              </div>
            </div>
          </footer>
          <CookieConsent
            containerClasses="cookie-consent"
            location="bottom"
            buttonText="Accept"
            cookieName="ps_session"
            disableStyles={true}
            disableButtonStyles={true}
            buttonClasses="button button--black"
            expires={9999}
            onAccept={() => this.onAcceptConsent()}
          >
            <div>
              This website uses cookies.<br />
              By using this website you consent to our use of these cookies.<br /><br />
              <span className="">For more information visit our { ' ' }
                <Link to="/privacy-policy">Privacy Policy</Link>.</span>
            </div>
          </CookieConsent>
        </TemplateWrapperContext.Provider>
      </div>
    );
  }
}

export default withI18n()(TemplateWrapper);
export const TemplateWrapperContext = React.createContext();
